import { useMemo } from 'react';

import type { Ticket, TicketList } from '@rtkwlf/rendall';
import uniqBy from 'lodash/uniqBy';

export const useDedupeTickets = (pages: TicketList[] | undefined) => {
  return useMemo(() => {
    if (!pages) return [];

    const flattened = (pages.map((p) => p.tickets).flat() ??
      []) as Required<Ticket>[];

    return uniqBy(flattened, 'id');
  }, [pages]);
};
